import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col invoice-list" }
const _hoisted_2 = { class: "flex w-full items-center gap-3 px-3 py-2.5 text-sm font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_3 = { class: "w-100 flex justify-between items-center text-left breakable" }
const _hoisted_4 = { class: "fa-solid fa-spinner animate-spin" }
const _hoisted_5 = { class: "flex flex-col pl-3" }
const _hoisted_6 = { class: "inline-flex items-center space-x-2 cursor-pointer select-none" }
const _hoisted_7 = ["checked", "onInput"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "w-full flex justify-between items-center text-left" }
const _hoisted_10 = { class: "text-yellow-400 mr-1 fa-solid fa-circle-exclamation" }
const _hoisted_11 = { class: "text-error mr-1 fa-solid fa-circle-xmark" }
const _hoisted_12 = { class: "fa-solid fa-pause mr-1" }
const _hoisted_13 = { class: "fa-solid fa-floppy-disk mr-1" }
const _hoisted_14 = { class: "text-success fa-solid fa-circle-check" }
const _hoisted_15 = { class: "text-error fa-solid fa-circle-xmark" }
const _hoisted_16 = { class: "fa-solid fa-spinner animate-spin" }
const _hoisted_17 = {
  key: 0,
  class: "sticky bottom-0 border-b border-gray-200 last:border-b-0 dark:border-gray-800"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.files, (file) => {
      return (_openBlock(), _createElementBlock("li", {
        key: file.id.get(),
        class: "border-b border-gray-200 last:border-b-0 dark:border-gray-800"
      }, [
        _createElementVNode("span", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("span", null, [
            _createElementVNode("i", { class: "fa-regular fa-file-pdf" })
          ], -1 /* CACHED */)),
          _createElementVNode("span", _hoisted_3, [
            _createTextVNode(_toDisplayString(file.file_name) + " ", 1 /* TEXT */),
            _withDirectives(_createElementVNode("i", _hoisted_4, null, 512 /* NEED_PATCH */), [
              [_vShow, file.loading]
            ])
          ]),
          _withDirectives(_createVNode($setup["Confirm_button"], {
            onClick: $event => ($setup.delete_file(file)),
            size: $setup.Size.small
          }, {
            confirmation_text: _withCtx(() => [
              _cache[0] || (_cache[0] = _createElementVNode("p", null, "Are you sure you want to remove", -1 /* CACHED */)),
              _cache[1] || (_cache[1] = _createElementVNode("p", null, " ", -1 /* CACHED */)),
              _createTextVNode(" " + _toDisplayString(file.file_name) + "? ", 1 /* TEXT */)
            ]),
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createTextVNode(" Remove file "))
            ]),
            _: 2 /* DYNAMIC */,
            __: [2]
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "size"]), [
            [_vShow, !file.loading]
          ])
        ]),
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(file.invoices, (invoice) => {
            return (_openBlock(), _createElementBlock("li", {
              key: invoice.id.get(),
              class: _normalizeClass(["border-b border-gray-200 last:border-b-0 dark:border-gray-800", {"bg-red-200": invoice.duplicated}])
            }, [
              _createElementVNode("span", {
                class: _normalizeClass($setup.li_styles(invoice, $setup.prop_selected_invoice_ids))
              }, [
                _createElementVNode("label", _hoisted_6, [
                  _createElementVNode("input", {
                    checked: !invoice.excluded,
                    onInput: $event => ($setup.exclude_invoice($event, file, invoice)),
                    type: "checkbox",
                    class: "peer hidden"
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-5 h-5 rounded border-2 border-gray-400 peer-checked:border-blue-600 peer-checked:bg-blue-600 flex items-center justify-center transition-colors" }, [
                    _createElementVNode("svg", {
                      class: "hidden w-3 h-3 text-white peer-checked:block",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "3",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M5 13l4 4L19 7"
                      })
                    ])
                  ], -1 /* CACHED */))
                ]),
                _createElementVNode("button", {
                  class: "w-full",
                  onClick: $event => ($setup.select_invoice($event, file, invoice, $setup.prop_selected_invoice_ids))
                }, [
                  _createElementVNode("span", _hoisted_9, [
                    _withDirectives(_createElementVNode("span", null, " Unrecongnized invoice ", 512 /* NEED_PATCH */), [
                      [_vShow, invoice.invoice_information.vendor === '' || invoice.invoice_information.invoice_NaN === '']
                    ]),
                    _withDirectives(_createElementVNode("span", null, _toDisplayString(invoice.invoice_information.vendor) + " - " + _toDisplayString(invoice.invoice_information.invoice_NaN) + " " + _toDisplayString($setup.display_currency(invoice.invoice_information.total)), 513 /* TEXT, NEED_PATCH */), [
                      [_vShow, invoice.invoice_information.vendor !== '' && invoice.invoice_information.invoice_NaN !== '']
                    ]),
                    _createElementVNode("span", null, [
                      _withDirectives(_createElementVNode("i", _hoisted_10, null, 512 /* NEED_PATCH */), [
                        [_vShow, invoice.not_found]
                      ]),
                      _withDirectives(_createElementVNode("i", _hoisted_11, null, 512 /* NEED_PATCH */), [
                        [_vShow, invoice.error || invoice.invoice_information.invoice_NaN === '8842040-00']
                      ]),
                      _withDirectives(_createElementVNode("i", _hoisted_12, null, 512 /* NEED_PATCH */), [
                        [_vShow, invoice.paused]
                      ]),
                      _withDirectives(_createElementVNode("i", _hoisted_13, null, 512 /* NEED_PATCH */), [
                        [_vShow, invoice.downloaded]
                      ]),
                      _withDirectives(_createElementVNode("i", _hoisted_14, null, 512 /* NEED_PATCH */), [
                        [_vShow, !invoice.loading && invoice.stamped]
                      ]),
                      _withDirectives(_createElementVNode("i", _hoisted_15, null, 512 /* NEED_PATCH */), [
                        [_vShow, !invoice.loading && !invoice.stamped]
                      ]),
                      _withDirectives(_createElementVNode("i", _hoisted_16, null, 512 /* NEED_PATCH */), [
                        [_vShow, invoice.loading]
                      ])
                    ])
                  ])
                ], 8 /* PROPS */, _hoisted_8)
              ], 2 /* CLASS */)
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */)),
          ($setup.multiple_selected_in_file(file, $setup.prop_selected_file_id, $setup.prop_selected_invoice_ids))
            ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                _createVNode($setup["Basic_button"], {
                  onClick: $event => ($setup.merge_invoices(file, $setup.prop_selected_invoice_ids)),
                  size: $setup.Size.small,
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("Merge Invoices")
                  ]))]),
                  _: 2 /* DYNAMIC */,
                  __: [5]
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "size"])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ], 512 /* NEED_PATCH */)), [
    [_vShow, $props.files.length > 0]
  ])
}